import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { defineNuxtPlugin } from '#app';
import { useAuthStore } from '~/stores/auth'

export default defineNuxtPlugin((nuxtApp) => {
    const firebaseConfig = {
        apiKey: "AIzaSyB4QuzVA6xQJ3dMftQR4uD_EcNJd-qrHyo",
        authDomain: "w-ecommerce2.firebaseapp.com",
        projectId: "w-ecommerce2",
        storageBucket: "w-ecommerce2.firebasestorage.app",
        messagingSenderId: "665429353688",
        appId: "1:665429353688:web:6661f0958b60a38c2a23ad",
        measurementId: "G-QVZ5XB5SGF"
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Analytics only runs in client-side
    let analytics = null;
    if (process.client) {
        analytics = getAnalytics(app);
    }

    const auth = getAuth(app);
    const firestore = getFirestore(app);
    const storage = getStorage(app);

    // Sync Firebase Auth with Pinia Store
    if (process.client) {
        const authStore = useAuthStore();
        auth.onAuthStateChanged((user) => {
            authStore.user = user;
            authStore.isInitialSyncDone = true;
        });
    }

    // Provide firebase instances globally to the app
    return {
        provide: {
            firebase: app,
            auth: auth,
            db: firestore,
            storage: storage,
            analytics: analytics
        }
    };
});
